module.exports = {
	"debug": {
		"debug": "1",
		"logips": 1
	},
	"chain": {
		"chain": "test"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Presets/testnet.json
 ** module id = 48
 ** module chunks = 0
 **/